import React, { PureComponent } from 'react';
import ActivityIndicator from '~/UI/ActivityIndicator';

interface Props {
	targetUserId: string | null;
	onLoad: (userId: string | null) => any;
}

export default class ImpersonatePage extends PureComponent<Props> {
	componentDidMount() {
		const { targetUserId, onLoad } = this.props;
		onLoad(targetUserId);
	}

	render() {
		return <ActivityIndicator />;
	}
}
